<template>
  <b-modal id="settlementDetailModal" title="결제 상세정보" size="lg" @hidden="fn_reset">
    <div v-if="detailInfo" class="modal_detail">

      <!-- 주문 정보 -->
      <h3 class="section_title">주문 정보</h3>
      <div class="table_list mb20">
        <table class="write detail_table">
          <colgroup>
            <col style="width: 20%">
            <col style="width: 30%">
            <col style="width: 20%">
            <col style="width: 30%">
          </colgroup>
          <tbody>
            <tr>
              <th><span>주문코드</span></th>
              <td>{{ detailInfo.order_code }}</td>
              <th><span>접수일시</span></th>
              <td>{{ detailInfo.reg_dt }}</td>
            </tr>
            <tr>
              <th><span>처방명</span></th>
              <td>{{ detailInfo.prescribe_nm }}</td>
              <th><span>처방의</span></th>
              <td>{{ detailInfo.doctor_nm }}</td>
            </tr>
            <tr>
              <th><span>환자명</span></th>
              <td colspan="3">{{ detailInfo.patient_nm }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 결제 정보 -->
      <h3 class="section_title">결제 정보</h3>
      <div class="table_list mb20">
        <table class="write detail_table">
          <colgroup>
            <col style="width: 20%">
            <col style="width: 30%">
            <col style="width: 20%">
            <col style="width: 30%">
          </colgroup>
          <tbody>
            <tr>
              <th><span>결제상태</span></th>
              <td>
                  <span class="status_badge" :class="getPaymentBadgeClass(detailInfo.payment_status)">
                    {{ detailInfo.payment_status_nm }}
                  </span>
              </td>
              <th><span>결제완료일시</span></th>
              <td>{{ detailInfo.payment_complete_dt }}</td>
            </tr>
            <tr>
              <th><span>주문금액</span></th>
              <td class="ar">{{ fn_comma_won(detailInfo.total_price) }}원</td>
              <th><span>결제유형</span></th>
              <td>{{ detailInfo.payment_type_nm }}</td>
            </tr>
            <tr>
              <th><span>카드결제금액</span></th>
              <td class="ar">{{ fn_comma_won(detailInfo.card_price) }}원</td>
              <th><span>무통장입금</span></th>
              <td class="ar">{{ fn_comma_won(detailInfo.bank_price) }}원</td>
            </tr>
            <tr>
              <th><span>예치금사용금액</span></th>
              <td class="ar">{{ fn_comma_won(detailInfo.deposit_used_price) }}원</td>
              <th><span>포인트사용금액</span></th>
              <td class="ar point_amt">{{ fn_comma_won(detailInfo.point_used_price) }}원</td>
            </tr>
            <tr>
              <th><span>실결제금액</span></th>
              <td class="ar real_amt" colspan="3">{{ fn_comma_won(detailInfo.pay_price + detailInfo.deposit_used_price) }}원</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!--
      <h3 class="section_title">정산 정보</h3>
      <div class="table_list mb20">
        <table class="write">
          <colgroup>
            <col width="160">
            <col width="*">
            <col width="160">
            <col width="*">
          </colgroup>
          <tbody>
            <tr>
              <th><span>정산상태</span></th>
              <td>
                <span class="status_badge" :class="getSettleBadgeClass(detailInfo.settle_status)">
                  {{ detailInfo.settle_status_nm }}
                </span>
              </td>
              <th><span>정산완료일시</span></th>
              <td>{{ detailInfo.settle_complete_dt || '-' }}</td>
            </tr>
            <tr>
              <th><span>비고</span></th>
              <td colspan="3">{{ detailInfo.settle_memo || '-' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      -->

    </div>
    <div v-else class="ac pt20 pb20">
      <span>데이터를 불러오는 중입니다.</span>
    </div>

    <template #modal-footer>
      <b-button class="btn btn_md btn_brown" @click="$bvModal.hide('settlementDetailModal')">확인</b-button>
    </template>
  </b-modal>
</template>

<script>
  // import axios from 'axios'
  import commonUtil from '@/mixin/commonUtil'

  export default {
    name: 'settlementDetailModal',
    mixins: [commonUtil],
    props: {
      selectedItem: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        detailInfo: null
      }
    },
    watch: {
      selectedItem(newVal) {
        if (newVal) {
          this.fn_load_detail(newVal)
        }
      }
    },
    methods: {
      fn_load_detail(item) {
        // TODO: API 연동 시 아래 주석 해제 후 더미 데이터 제거
        // axios.post('/api/admin/settlement/getSettlementDetail', { order_code: item.order_code })
        //   .then((res) => {
        //     this.detailInfo = res.data.settlementDetail
        //   })
        //   .catch((err) => console.log(err))

        // 더미: 전달받은 item을 그대로 사용
        this.detailInfo = { ...item }
      },
      fn_reset() {
        this.detailInfo = null
      },
      getPaymentBadgeClass(status) {
        if (status === 'COMP') return 'badge_blue'
        if (status === 'CANC') return 'badge_red'
        return ''
      }
      // getSettleBadgeClass(status) {
      //   if (status === 'SET02') return 'badge_green'
      //   if (status === 'SET01') return 'badge_gray'
      //   return ''
      // }
    }
  }
</script>

<style scoped>
  .section_title {
    font-size: 1.5rem;
    font-weight: 700;
    color: #262939;
    border-left: 3px solid #262939;
    padding-left: 10px;
    margin-bottom: 10px;
  }
  .mb20 { margin-bottom: 20px; }
  .pt20 { padding-top: 20px; }
  .pb20 { padding-bottom: 20px; }
  .ac { text-align: center; }
  .ar { text-align: right; }

  /* 두 테이블 모두 table-layout: fixed 로 colgroup % 비율을 강제 적용 */
  .detail_table { table-layout: fixed; width: 100%; }

  .real_amt { color: #2b6cb0; font-weight: 600; }
  .point_amt   { color: #28a745; font-weight: 600; }

  .status_badge {
    display: inline-block;
    padding: 3px 10px;
    border-radius: 12px;
    font-size: 1.2rem;
    font-weight: 600;
  }
  .badge_blue  { background: #ebf4ff; color: #2b6cb0; }
  .badge_red   { background: #fff5f5; color: #c53030; }
  /* .badge_green { background: #f0fff4; color: #276749; } */
  /* .badge_gray  { background: #f7fafc; color: #718096; } */
</style>